import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { KycCaseDto, KycCaseFilter } from "@/features/kyc/api/dto";

/**
 * Liste paginée des dossiers KYC (`POST /KycCases/all` — les listes sont en
 * POST, guide §4.2). Base de la file de travail du back-office : filtrable
 * par identité, statut, canal ou agent assigné.
 */
export const useKycCases = (
  params: ListRequest<KycCaseFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_CASES_LIST(params),
    queryFn: () =>
      mutateData({
        url: kycEndpoints.kycCases.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<KycCaseDto>>,
    enabled,
  });
